export const cafeteriaBoutique = {
  descripcion: "En el corazón de la Patagonia Chilena, nuestra cafetería boutique te invita a vivir una experiencia única. Disfruta de café de especialidad, facturas y sándwiches, y descubre nuestra seleccionada vitrina de ropa, todo en un ambiente cálido que refleja la esencia de Coyhaique.",
  beneficios: [
    {
      icon: "ri-cup-line",
      titulo: "Café de Especialidad",
      descripcion: "Granos seleccionados y métodos de preparación artesanales para cada taza"
    },
    {
      icon: "ri-restaurant-line",
      titulo: "Facturas y Sándwiches",
      descripcion: "Deliciosas facturas y sándwiches frescos para acompañar tu café"
    },
    {
      icon: "ri-fire-line",
      titulo: "Ambiente Cálido",
      descripcion: "Un espacio acogedor inspirado en la calidez de una casona patagónica"
    },
    {
      icon: "ri-shirt-line",
      titulo: "Vitrina Boutique",
      descripcion: "Ropa de calidad premium, de retorno con etiquetas y marcas conocidas"
    }
  ]
};